// Demo helpers: friendly name + driver-number extraction.

// Hardcoded for the demo. Every driver shows as Herb until we have real
// driver-roster names wired in.
export function getFriendlyName(/* driverId */) {
  return 'Herb';
}

// Extracts the operational driver-number from a driver display name like
// "Driver 2" → "Drv 2". Falls back to the original string if no number found.
export function getDrvLabel(name) {
  if (!name) return 'Drv ?';
  const m = name.match(/(\d+)/);
  return m ? `Drv ${m[1]}` : name;
}

// What to show in the "Gate" column for a flight on the driver app.
// Matches the print-page convention: cold bags go to Cold Sort, cancelled
// + overnight bags go to Reroutes, everything else shows the actual gate.
export function displayGate(flight) {
  if (!flight) return '?';
  if (flight.connectionCategory === 'cancelled') return 'Reroutes';
  if (flight.isOvernight) return 'Reroutes';
  if (flight.connectionCategory === 'cold') return 'Cold Sort';
  return flight.gate || '?';
}

// Human-readable label for each in-run state, used on the home screen
// when the driver is mid-run.
export const STAGE_LABELS = {
  assignment_detail: 'Reviewing assignment',
  at_gate: 'Heading to inbound gate',
  download: 'Downloading bags',
  download_report: 'Download report',
  drive: 'On the road',
  end_run: 'Wrapping up',
};
